<template>
  <div>
    <page-header :title="$t('bill.bill_config')" />
    <page-body>
      <billshield-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import BillshieldList from './components/List'

export default {
  name: 'BillShieldIndex',
  components: {
    BillshieldList,
  },
  data () {
    return {
      listId: 'BillShieldList',
    }
  },
  computed: {
    getParams () {
      return {}
    },
  },
}
</script>
